import React, { useContext } from 'react';
import { BaseContext } from '@/contexts/BaseContext';
import { useI18n } from '../../_contexts/I18nContext';
import Header from '../Header';
import Banner from '../Banner/Secondary';
import Roles from '../Roles';
import Thumbnail from '../Partner/Thumbnail';
import QRCode from '../QRCode';
import Footer from '../Footer';
import styles from './index.module.scss';
import Cases from '../Cases';
import { transformUrlWithRegion } from '@/utils';
import { logger } from '@/pages/business/utils/lib';
import ArrowRight from '@/static/images/business/ArrowRight.svg';
import { isBrowser } from '@ies/ace';

const Container = ({
  casesData,
  dropDownData
}) => {
  const {
    region
  } = useContext(BaseContext);
  console.log('partner page', region, isBrowser(), ' : ', typeof IS_TTP, '---');
  const I18n = useI18n();
  const isCB = region === 'zh';
  const qrCode = [];

  switch (region) {
    case 'en':
      qrCode.push({
        img: '/images/business/creator/qrcode/en-00-20220614.png',
        link: 'https://partner.tiktokshop.com/',
        clickFor: 'qrcode for uk tsp'
      });
      break;

    case 'id':
      qrCode.push({
        img: '/images/business/creator/qrcode/id-00-20220614.png',
        link: 'https://partner.tiktokshop.com/',
        clickFor: 'qrcode for id tsp'
      });
      break;

    default:
      qrCode.push({
        img: '/images/business/creator/qrcode/zh-00-20220614.png',
        link: 'https://partner.tiktokshop.com/',
        clickFor: 'qrcode for cb tsp'
      });
      break;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Header, {
    sellerDropdownData: dropDownData.seller,
    learningDropdownData: dropDownData.learning
  }), /*#__PURE__*/React.createElement(Banner, {
    name: "Partner_ATF",
    slogan: I18n.t('TTS_Portal_Partner_ATF_title'),
    desc: I18n.t('TTS_Portal_Partner_ATF_desc'),
    img: "/images/business/banner/partner.png",
    showButton: true
  }), /*#__PURE__*/React.createElement(Roles, {
    name: "Partner_Intro",
    className: styles.roles,
    data: [{
      img: '/images/business/roles/04-20211214.jpg',
      title: I18n.t('TTS_Portal_Partner_Intro_title_1'),
      desc: I18n.t('TTS_Portal_Partner_Intro_title1_desc')
    }, isCB ? {
      img: '/images/business/roles/05.jpg',
      title: I18n.t('TTS_Portal_Partner_Intro_cb_title_2'),
      desc: I18n.t('TTS_Portal_Partner_Intro_cb_title2_desc')
    } : {
      img: '/images/business/roles/06.jpg',
      title: I18n.t('TTS_Portal_Partner_Intro_title_2'),
      desc: I18n.t('TTS_Portal_Partner_Intro_title2_desc')
    }]
  }), /*#__PURE__*/React.createElement(Thumbnail, {
    name: "Partner_Incentive_left",
    className: styles.thumbnail3,
    data: {
      img: '/images/business/thumbnail/2-20211214.png',
      title: I18n.t('TTS_Portal_Partner_Incentive_left_title'),
      briefs: [{
        title: I18n.t('TTS_Portal_Partner_Incentive_left_point_1'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_left_point1_desc')
      }, {
        title: I18n.t('TTS_Portal_Partner_Incentive_left_point_2'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_left_point2_desc')
      }, {
        title: I18n.t('TTS_Portal_Partner_Incentive_left_point_3'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_left_point3_desc')
      }, {
        title: I18n.t('TTS_Portal_Partner_Incentive_left_point_4'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_left_point4_desc')
      }]
    }
  }), /*#__PURE__*/React.createElement(Thumbnail, {
    reverse: true,
    name: "Partner_Incentive_right",
    className: styles.thumbnail4,
    data: {
      img: isCB ? '/images/business/thumbnail/4.png' : '/images/business/thumbnail/3.png',
      title: I18n.t(isCB ? 'TTS_Portal_Partner_Incentive_right_title_cb' : 'TTS_Portal_Partner_Incentive_right_title'),
      briefs: [{
        title: I18n.t('TTS_Portal_Partner_Incentive_right_point_1'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_right_point1_desc')
      }, {
        title: I18n.t('TTS_Portal_Partner_Incentive_right_point_2'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_right_point2_desc')
      }, {
        title: I18n.t('TTS_Portal_Partner_Incentive_right_point_3'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_right_point3_desc')
      }, {
        title: I18n.t('TTS_Portal_Partner_Incentive_left_point_4'),
        desc: I18n.t('TTS_Portal_Partner_Incentive_right_point4_desc')
      }]
    }
  }), isBrowser() && IS_TTP ? null : /*#__PURE__*/React.createElement(Cases, {
    name: "Partner_CaseStudies",
    data: casesData,
    suffix: /*#__PURE__*/React.createElement("a", {
      href: transformUrlWithRegion('/business/outstanding-partners', region),
      className: `btn btn-primary btn-lg ${styles.casesButton}`,
      onClick: () => logger.sendButtonClick({
        page_name: 'tts_portal_partners_page',
        click_for: 'view_all_partners'
      })
    }, I18n.t('tts_portal_creator_showcase_btn_viewall'), /*#__PURE__*/React.createElement(ArrowRight, null))
  }), /*#__PURE__*/React.createElement(QRCode, {
    name: "Partner_HTJ",
    className: styles.qrcode,
    title: I18n.t('TTS_Portal_Partner_HTJ_title'),
    desc: I18n.t(!isCB ? 'TTS_Portal_Creator_HTJ_id_desc' : 'TTS_Portal_Partner_HTJ_desc'),
    list: qrCode
  }), /*#__PURE__*/React.createElement(Footer, null));
};

export default Container;